import { render, staticRenderFns } from "./EditStadionTatjana01.vue?vue&type=template&id=4d4dff96&"
import script from "./EditStadionTatjana01.vue?vue&type=script&lang=js&"
export * from "./EditStadionTatjana01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports